import { IApplicationState } from '../../types/redux';

export const selectPrice = (state: IApplicationState) => state.legalCheck.price;
